import keyLabelsSearch from "./keyLabelsSearch";

const getSearchString = (obj) =>
  Object.keys(obj).reduce((acc, el) => acc + `${keyLabelsSearch[el]}=${obj[el]},`, "");

export default getSearchString;
